import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import SvgLogo from '../generated/svg/logo'

const Outer = styled.div`
  display: flex;
  justify-content: center;
  padding: 3rem 0 4rem;
  gap: 3rem;
  align-items: center;
  @media (max-width: 40rem){
    flex-direction: column;
    padding-top: 5rem;
  }
`

const LogoContainer = styled.div`
  svg {
    height: 4rem;
    width: auto;
    @media (max-width: 40rem){
      height: 3.5rem;
    }
  }
`

const AddressContainer = styled.div`
  font-size: 0.8rem;
  line-height: 1.75;
  @media (max-width: 40rem){
    text-align: center;
  }
`

type FooterProps = {

}
export const Footer: FunctionComponent<FooterProps> = () => {
  return <Outer>
    <LogoContainer>
      <SvgLogo />
    </LogoContainer>
    <AddressContainer>
      認定こども園ムロノキッズ<br />
      室の木幼稚園・プリスクール室の木<br />
      <br />
      〒233-0003　横浜市港南区港南3-35-20 <br />
      TEL:045-844-1107　FAX:045-844-1367
    </AddressContainer>
    <AddressContainer>
      小規模保育所<br />
      学校法人北見学園 キッズアミ<br />
      <br />
      〒233-0003　横浜市港南区3-34-15<br />
      TEL:045-846-0131　FAX:045-846—0132
    </AddressContainer>
  </Outer>
}